module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"stop":"Exit simulation mode","title":"User Simulation."},"de":{"stop":"Benutzer Simulation beenden","title":"Benutzer Simulation."},"fr":{"stop":"Quitter le mode simulation","title":"Mode Simulation"},"it":{"stop":"Uscire dal modo simulazione","title":"Modo simulazione."}}')
  delete Component.options._Ctor
}
